var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "496pt",
    viewBox: "0 0 496 496",
    width: "496pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A243A",
    d: "m456 128h-56v-128h-352v128h-8c-22.054688 0-40 17.945312-40 40v240c0 22.054688 17.945312 40 40 40h104v32h-32v16h272v-16h-32v-32h104c22.054688 0 40-17.945312 40-40v-240c0-22.054688-17.945312-40-40-40zm-72 64h16v48h-16zm-16 16h-144v-16h144zm-160 28.457031-45.703125-17.136719c-1.375-.519531-2.296875-1.847656-2.296875-3.320312s.921875-2.800781 2.304688-3.320312l45.695312-17.136719zm16-12.457031h144v16h-144zm192-32h8c13.230469 0 24 10.769531 24 24s-10.769531 24-24 24h-8zm-201.457031-16-57.855469 21.695312c-7.582031 2.839844-12.6875 10.199219-12.6875 18.304688s5.105469 15.464844 12.679688 18.304688l57.863281 21.695312h169.457031v80h-320v-256h320v96zm169.457031-160v48h-320v-48zm-344 128h8v208h352v-96h24c22.054688 0 40-17.945312 40-40s-17.945312-40-40-40h-24v-32h56c13.230469 0 24 10.769531 24 24v216h-464v-216c0-13.230469 10.769531-24 24-24zm296 336h-176v-32h176zm120-48h-416c-13.230469 0-24-10.769531-24-24v-8h464v8c0 13.230469-10.769531 24-24 24zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A243A",
    d: "m80 32h16v16h-16zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A243A",
    d: "m112 32h16v16h-16zm0 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A243A",
    d: "m144 32h16v16h-16zm0 0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m80 160h96v-64h-96zm16-48h64v32h-64zm0 0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A243A",
    d: "m200 96v64h96v-64zm80 48h-64v-32h64zm0 0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m80 176h56v16h-56zm0 0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A243A",
    d: "m80 208h48v16h-48zm0 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m80 240h56v16h-56zm0 0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A243A",
    d: "m80 272h288v16h-288zm0 0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m352 304h16v16h-16zm0 0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0A243A",
    d: "m80 304h256v16h-256zm0 0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebDesign);
export default __webpack_public_path__ + "static/media/web-design.cf3d6de8ae1f0a950e8c0ae4e7e0cf1c.svg";
export { ForwardRef as ReactComponent };